// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1NXOd","boxTitle":"Qualiphy_boxTitle__1_evp","box":"Qualiphy_box__2f2o-","toggleWrap":"Qualiphy_toggleWrap__2V9Br"};